<template>
  <customFooter class="footer">
    <div class="b-row">
      <span class="text-muted mx-auto">Copyright © 2020 Open Healthcare. All rights reserved.</span>
    </div>
  </customFooter>
</template>


<script>
export default {
  name: 'customFooter',
  components: {
  },
  props: {
  }
}
</script>

<style lang="less">
.row-no-padding{
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/professional/customaFooter.vue